export default "__VITE_ASSET__c53c9b8f__"